import React, {
  useState,
  useMemo,
  Fragment,
  memo,
  useEffect,
  useRef,
} from "react";
import _, { isArray } from "lodash";
import { useTable } from "react-table";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { format, differenceInDays, setHours } from "date-fns";
import Swal from "sweetalert2";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import Select from "react-select";
import { EmitterStatus } from "../../event";
import { checkRole } from "../../utils/role";
import { Dialog, Transition } from "@headlessui/react";
import {
  ExclamationIcon,
  InformationCircleIcon,
} from "@heroicons/react/outline";
import ReactJson from "react-json-view";
import {
  calcuratorInterest,
  calcuratorInterestTwo,
  getAllowedNewInstallmentCount,
  MAX_INSTALLMENTS,
} from "../../utils/reinstallments";

// COMPONENTS
import LoadingPage from "../Loading/LoadingPage";
import ContainerContent from "../Container/ContainerContent";

// HOOKS
import useLoanSandboxId from "../../hooks/useLoanSandboxId";

// UTILS
import {
  getCurrentLocalDateTime,
  pad,
  months,
} from "../../utils/getLocalDateTime";
import {
  calculatorDisabledPeriodRemain,
  getCheckCurrentDate,
  getTotalAmount,
} from "../../utils/calculator";

// OTHER
import numeral from "numeral";

// AWS
import { S3Image } from "aws-amplify-react";
import { API, Auth, Storage } from "aws-amplify";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getDetailSegment } from "utils/buro";
import { reinstallments } from "utils/reinstallments";

const optionsPeriod = [
  {
    label: "3",
    value: "3",
  },
  {
    label: "6",
    value: "6",
  },
  {
    label: "12",
    value: "12",
  },
  {
    label: "24",
    value: "24",
  },
  {
    label: "36",
    value: "36",
  },
  {
    label: "48",
    value: "48",
  },
  {
    label: "60",
    value: "60",
  },
];

const optionsPackage = [
  {
    label: "อุปโภค / บริโภค",
    value: "อุปโภค / บริโภค",
  },
  {
    label: "ท่องเที่ยว",
    value: "ท่องเที่ยว",
  },
  {
    label: "ธุรกิจ",
    value: "ธุรกิจ",
  },
];

const colorStatus = (status) => {
  if (status == "ACTIVE") return "text-green-500";
  if (status == "REFINANCE") return "text-purple-500";
  if (status == "DONE") return "text-green-600";
  if (status == "PENDING") return "text-yellow-500";

  return "text-red-500";
};

const today = getCurrentLocalDateTime();

export const ModalDialog = ({
  search,
  setSearch,
  onChangeSearch,
  setModal,
  modal,
  ref,
  dataJson,
  title,
  isSearch = false,
  ...props
}) => {
  return (
    <Transition.Root show={modal} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-50 inset-0 overflow-y-auto w-full"
        initialFocus={ref}
        onClose={setModal}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 w-full">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="w-full inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                    <InformationCircleIcon
                      className="h-6 w-6 text-blue-600"
                      aria-hidden="true"
                    />
                  </div>
                  <div className="mt-3 w-full  ml-4 text-left">
                    <Dialog.Title
                      as="h3"
                      className="text-lg leading-6 font-medium text-gray-900 flex flex-row items-center justify-between"
                    >
                      <div> {title}</div>
                      {isSearch && (
                        <div>
                          <input
                            onChange={onChangeSearch}
                            placeholder="Search tag, key"
                            value={search}
                            className="px-3  py-3 placeholder-blueGray-400 text-gray-600 relative bg-white rounded text-sm border-0 shadow outline-none focus:outline-none focus:ring w-full"
                          />
                        </div>
                      )}
                    </Dialog.Title>

                    <div className="mt-2 w-full">
                      <div className="text-sm leading-5 text-gray-500">
                        <ReactJson
                          src={dataJson}
                          name={false}
                          enableClipboard={false}
                          displayObjectSize={false}
                          displayDataTypes={false}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => setModal(false)}
                  ref={ref}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

function LoanId() {
  const { user } = useSelector((state) => state.initializeApp);

  const [selectMonth, setSelectMonth] = useState(pad(today.month));
  const [selectDate, setSelectDate] = useState(pad(today.date));
  const [selectYear, setSelectYear] = useState(today.year);
  const [selectHour, setSelectHour] = useState(pad(today.hours));
  const [selectMinute, setSelectMinute] = useState(pad(today.minutes));
  const [checkTime, setCheckTime] = useState(false);

  const cancelButtonRef = useRef(null);
  const cancelPaymentButtonRef = useRef(null);
  const cancelLastPaymentButtonRef = useRef(null);
  const cancelBuroRef = useRef(null);

  const years = new Array(15).fill(2030).map((year, index) => {
    const value = year - index;
    return {
      label: value,
      value,
    };
  });

  const optionsYears = years;

  const optionsMonths = months
    // .slice(0, today.month)
    .map((_, index) => {
      return {
        label: `${pad(index + 1)}`,
        value: `${pad(index + 1)}`,
        index,
      };
    })
    .reverse();

  const dayOfMonth = months[selectMonth - 1].days;

  const optionsDates = new Array(dayOfMonth)
    .fill(dayOfMonth)
    // .slice(0, +selectDate)
    .map((_, index) => {
      const value = index + 1;
      return {
        label: `${pad(value)}`,
        value: `${pad(value)}`,
        index,
      };
    })
    .reverse();

  const optionsHours = useMemo(() => {
    return [{ label: "00", value: "00" }]
      .concat(
        new Array(23)
          .fill(23)
          //   .slice(0, +today.hours)
          .map((_, index) => {
            const value = index + 1;
            return {
              label: `${pad(value)}`,
              value: `${pad(value)}`,
              index,
            };
          })
      )
      .reverse();
  }, [selectHour]);

  const optionsMintues = useMemo(() => {
    return [{ label: "00", value: "00" }]
      .concat(
        new Array(59)
          .fill(59)
          //   .slice(0, +selectHour < +today.hours ? 59 : +today.minutes)
          .map((_, index) => {
            const value = index + 1;
            return {
              label: `${pad(value)}`,
              value: `${pad(value)}`,
              index,
            };
          })
      )
      .reverse();
  }, [selectHour, selectMinute]);

  const router = useHistory();
  const params = useParams();
  const {
    data,
    loading,
    error: errorQuery,
    getData,
    setData,
  } = useLoanSandboxId({
    loan_id: params.loan_id,
    paid_date: today.dateTime,
  });

  const handleApprove = useFullScreenHandle();
  const [butoData, setBuroData] = useState(null);

  const default_query = {
    paid_date: today.dateTime,
  };

  const default_form = {
    paid_date: today.dateTimeLocal,
    paid_amount: 0,
    bill_img: "",
    formatPay: "normal",
    newPeriod: "12",
    newInterest: data?.type,
  };

  const [isExpand, setExpand] = useState(false);
  const [showEvidence, setShowEvidence] = useState("");

  const [loadingReset, setResetLoading] = useState(false);
  const [loadingDebtor, setLoadingDebtor] = useState(false);
  const [loadingPayment, setLoadingPayment] = useState(false);
  const [loadingLastPayment, setLoadingLastPayment] = useState(false);
  const [loadingInstallment, setLoadingInstallment] = useState(false);
  const [error, setError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [billBase, setBillBase] = useState("");
  const [form, setForm] = useState(default_form);
  const [query, setQuery] = useState(default_query);
  const [preview, setPreview] = useState([]);
  const [modalDebtor, setModalDebtor] = useState(false);
  const [modalAfterPayment, setModalAfterPayment] = useState(false);
  const [modalLastPayment, setModalLastPayment] = useState(false);
  const [dataAfterPayment, setDataAfterPayment] = useState([]);
  const [dataDebtor, setDataDebtor] = useState([]);
  const [dataLastPayment, setDataLastPayment] = useState([]);
  const [loadingBuro, setLoadingBuro] = useState(false);
  const [openBuro, setOpenBuro] = useState(false);
  const [search, setSearch] = useState("");

  const [loadingUpdateInstallment, setLoadingUpdateInstallment] =
    useState(false);
  const [isNewPeriod, setIsNewPeriod] = useState(false);
  const [formNewPeriod, setFormNewPeriod] = useState({
    number_period: 6,
    new_installments: [],
  });

  const onChangeSearch = (e) => {
    const { value } = e.target;

    const oriRowModal = getDetailSegment({
      currentDate: query?.paid_date,
      dataExport: [_.cloneDeep(data)],
      showLog: true,
      showConsole: true,
    });
    setBuroData((prev) => {
      return oriRowModal?.filter((row) => {
        return (
          row?.tag?.toLowerCase().includes(value.toLowerCase()) ||
          row?.key?.toLowerCase().includes(value.toLowerCase())
        );
      });
    });
    setSearch(value);
  };

  const getDataEvidence = () => {
    if (!data?.evidence?.length) return null;
    const filterPending = data.evidence.filter(
      (ev) => ev.evidence_status === "PENDING"
    );
    const lastIndex = filterPending.length - 1;
    return filterPending[lastIndex];
  };

  useEffect(() => {
    if (!data) return;
    const dataEvidence = getDataEvidence();
    setExpand(!!dataEvidence);
    setForm((prev) => {
      return {
        ...prev,
        paid_date: dataEvidence?.paid_date || today.dateTimeLocal,
        paid_amount: dataEvidence ? +dataEvidence.paid_amount : 0,
      };
    });
    if (dataEvidence?.paid_date) {
      const paid_date = getCurrentLocalDateTime(
        new Date(dataEvidence?.paid_date)
      );
      setSelectDate(pad(paid_date.date));
      setSelectMonth(pad(paid_date.month));
      setSelectYear(pad(paid_date.year));
      setSelectHour(pad(paid_date.hours));
      setSelectMinute(pad(paid_date.minutes));
    }
  }, [data, loading]);

  if (loading) {
    return (
      <ContainerContent>
        <LoadingPage />
      </ContainerContent>
    );
  }
  if (errorQuery) {
    <ContainerContent>Error...</ContainerContent>;
  }

  const dataEvidence = getDataEvidence();
  const evidence = data?.evidence?.sort((a, b) => {
    return a?.paid_date < b?.paid_date ? 1 : -1;
  });

  const onChangeDate = (e) => {
    setQuery((prev) => {
      return {
        ...prev,
        paid_date: e.target.value,
      };
    });
  };

  const onRefetch = async () => {
    await getData({ params: query });
    let last_installment = data.installments[data.installments.length - 1];
    let period = 1;
    if (formNewPeriod.new_installments.length > 0) {
      last_installment =
        formNewPeriod.new_installments[
          formNewPeriod.new_installments.length - 1
        ];
    }

    const check_date =
      getCurrentLocalDateTime(new Date(last_installment.date)).fullDate <
        getCurrentLocalDateTime(new Date(query.paid_date)).fullDate &&
      last_installment.actualPrinciple + last_installment.actualInterest > 0;
    if (check_date) {
      setFormNewPeriod((prev) => {
        return {
          ...prev,
          new_installments: cal_new_installment(
            formNewPeriod.new_installments.length + period
          ),
        };
      });
    }
  };
  const onSubmitEvidence = (evidence_status) => async (e) => {
    const result = await Swal.fire({
      title: "คุณยืนยันที่จะอนุมัตินี้หรือไม่ ?",
      showCancelButton: true,
      confirmButtonText: `บันทึก`,
      cancelButtonText: "ยกเลิก",
      showLoaderOnConfirm: true,
      showLoaderOnDeny: false,
      preConfirm: async () => {
        try {
          let errorMessage = "";
          let error = false;
          if (!dataEvidence && !billBase) {
            setError(true);
            errorMessage += "โปรดเลือกไฟล์";
            error = true;
          }
          if (+form.paid_amount === 0) {
            errorMessage = errorMessage
              ? ` และ โปรดกรอกจำนวนเงิน`
              : "โปรดกรอกจำนวนเงิน";
            error = true;
          }

          const total = data.installments.reduce((prev, installment) => {
            return (
              prev +
              installment.actualInterest +
              installment.interestMore +
              installment.actualPrinciple
            );
          }, 0);
          // if (total <= 0) {
          //   error = true;
          //   errorMessage = "ไม่สามารถจ่ายตังได้ เนื่องจากยอดเกินกำหนดที่ชำระ";
          // }
          // if (
          //   data.installments.every((installment) => installment.disabledPeriod)
          // ) {
          //   error = true;
          //   errorMessage = "ไม่สามารถจ่ายตังได้ เนื่องจากงวดปิดหมดแล้ว";
          // }

          if (error && evidence_status === "APPROVE") {
            setError(true);
            return { error, errorMessage };
          }

          let newBill_img = "";
          if (form.bill_img) {
            const fileName = `${new Date().getTime()}_${form?.bill_img?.name}`;
            newBill_img = await Storage.put(fileName, form.bill_img);
          }

          await API.put(
            "MoneyHubAdmin",
            `/loan/sandbox/evidence/${data.loan_id}`,
            {
              body: {
                paid_amount: +form.paid_amount,
                // paid_date: form.paid_date,
                paid_date: `${selectYear}-${pad(selectMonth)}-${pad(
                  selectDate
                )}T${pad(selectHour)}:${pad(selectMinute)}:${pad(
                  today.seconds
                )}`,
                adminName: user.username,
                _id: dataEvidence ? dataEvidence._id : "",
                isNew: !dataEvidence,
                bill_img: newBill_img ? newBill_img.key : dataEvidence.bill_img,
                evidence_status,
                test: true,
              },
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            }
          );
          setForm((prev) => {
            return {
              ...default_form,
              formatPay: prev.formatPay,
            };
          });
          setBillBase("");
        } catch (error) {
          await EmitterStatus("ERROR", { logMessage: error });
        }
      },
    });
    if (!result.isConfirmed) return;
    if (result.value.error) {
      return await EmitterStatus("WARNING", {
        text: result.value.errorMessage,
      });
    }
    await EmitterStatus("SUCCESS");
    await getData(query, { isLoading: false });
  };

  const onSelect = (name) => (e) => {
    const { value } = e;
    setForm((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const onChangeFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    getBase64(file);
    setForm((prev) => {
      return {
        ...prev,
        bill_img: file,
      };
    });
  };

  const onChangeForm = (e) => {
    setForm((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  const getBase64 = (file) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setBillBase(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  };

  const onFail = async () => {
    const { loan_id } = data;
    const result = await Swal.fire({
      title: "คุณยืนยันที่จะยกเลิกสัญญานี้หรือไม่ ? ?",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: `บันทึก`,
      cancelButtonText: "ยกเลิก",
      showLoaderOnConfirm: true,
      showLoaderOnDeny: false,
      preConfirm: async (reason) => {
        try {
          await API.put("MoneyHubAdmin", `/loan/sandbox/status/${loan_id}`, {
            body: {
              loan_status: "FAIL",
              reason,
              adminName: user.username,
              faild_by: user.username,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
        } catch (error) {
          await EmitterStatus("ERROR", { logMessage: error });
        }
      },
    });
    if (!result.isConfirmed) return;
    if (result.value.error) {
      return EmitterStatus("WARNING");
    }
    await EmitterStatus("SUCCESS");
    await getData(query, { isLoading: false });
  };

  const onRefinance = async () => {
    const result = await Swal.fire({
      title: "คุณยืนยันที่จะอนุมัตินี้หรือไม่ ?",
      showCancelButton: true,
      confirmButtonText: `บันทึก`,
      cancelButtonText: "ยกเลิก",
      showLoaderOnConfirm: true,
      showLoaderOnDeny: false,
      preConfirm: async () => {
        try {
          const {
            phone_number,
            request_id,
            requestamount,
            payPerMonth,
            loan_id,
            installments,
            interestMore,
            loan_kbank_id,
            capitalRemain,
          } = data;

          const installmentOpenLatest = installments.find(
            (installment) => !installment.disabledPeriod
          );
          const installmentOpenLatestIndex = installments.findIndex(
            (installment) => !installment.disabledPeriod
          );

          let newRequestAmount =
            capitalRemain + interestMore + installmentOpenLatest.actualInterest;

          const refinance_amount = newRequestAmount;

          const refinance_date = getCurrentLocalDateTime().isoDateTime;

          await API.post("MoneyHubAdmin", `/loanRequest/refinance`, {
            body: {
              loan_id,
              request_id,
              loan_kbank_id,
              requestamount: newRequestAmount,
              refinance_date,
              period: +form.newPeriod,
              purpose: data?.type,
              refinance_ar_loan: capitalRemain,
              refinance_interest:
                interestMore + installmentOpenLatest.actualInterest,
              refinance_accumulated_interest: interestMore,
              refinance_period: `${installmentOpenLatestIndex}/${installments.length}`,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });

          await API.put("MoneyHubAdmin", `/loan/sandbox/status/${loan_id}`, {
            body: {
              loan_status: "ACTIVE",
              refinance_amount,
              refinance_date,
              refinance_ar_loan: capitalRemain,
              refinance_interest:
                interestMore + installmentOpenLatest.actualInterest,
              refinance_accumulated_interest: interestMore,
              refinance_period: `${installmentOpenLatestIndex}/${installments.length}`,
              reason: "",
              adminName: user.username,
              faild_by: "",
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
        } catch (error) {
          await EmitterStatus("ERROR", { logMessage: error });
        }
      },
    });
    if (!result.isConfirmed) return;
    await EmitterStatus("SUCCESS");
    setShowModal(false);
    await getData(query, { isLoading: false });
  };

  const previewRefinance = async () => {
    const { interestMore, installments, capitalRemain } = data;

    const installmentOpenLatest = installments.find(
      (installment) => !installment.disabledPeriod
    );

    let newRequestAmount =
      capitalRemain + interestMore + installmentOpenLatest.actualInterest;
    const dataPreview = await API.get(
      "MoneyHubAdmin",
      "/loan/sandbox/preview",
      {
        queryStringParameters: {
          period: +form.newPeriod,
          requestamount: newRequestAmount,
          purpose: data.type,
          promo: 0,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      }
    );
    setPreview(JSON.parse(dataPreview.body).Item);
    setShowModal(true);
  };

  const showEvidencePopup = (index) => {
    setShowEvidence(index);
  };

  const getOption = (options, value) => {
    const findIndex = options.findIndex((option) => option.value === value);
    return options[findIndex];
  };

  const onSelectMonth = (e) => {
    const currentMonth = e;
    const diff_days = months[currentMonth.index].days - selectDate;
    if (diff_days < 0) {
      setSelectDate(`${pad(months[currentMonth.index].days)}`);
    }
    setSelectMonth(e.value);
  };

  const onSelectDate = (e) => {
    setSelectDate(e.value);
  };

  const onSelectYear = (e) => {
    setSelectYear(e.value);
  };

  const onSelectHour = (e) => {
    if (+e.value < +today.hours) {
      setSelectMinute(59);
    } else {
      const newToday = getCurrentLocalDateTime();
      setSelectMinute(pad(newToday.minutes));
    }
    setSelectHour(e.value);
  };

  const onSelectMintue = (e) => {
    setSelectMinute(e.value);
  };

  const onClickDebtor = async (e) => {
    try {
      setLoadingDebtor(true);

      const debtor = await API.get(
        "MoneyHubAdmin",
        `/loan/debtor/${data.loan_id}`,
        {
          queryStringParameters: {
            paid_date: query.paid_date,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      setModalDebtor(true);
      setDataDebtor(debtor);
    } catch (error) {
      console.log("error debtor", error);
    } finally {
      setLoadingDebtor(false);
    }
  };

  const onClickAfterPayment = async () => {
    try {
      setLoadingPayment(true);

      const afterPayment = await API.get(
        "MoneyHubAdmin",
        `/loan/debtor_payment_current/${data.loan_id}`,
        {
          queryStringParameters: {
            paid_date: query.paid_date,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      setModalAfterPayment(true);
      setDataAfterPayment(afterPayment);
    } catch (error) {
      console.log("after payment error", error);
    } finally {
      setLoadingPayment(false);
    }
  };

  const onClickLastPayment = async () => {
    try {
      setLoadingLastPayment(true);

      const lastPayment = await API.get(
        "MoneyHubAdmin",
        `/loan/debtor_payment/${data.loan_kbank_id}`,
        {
          queryStringParameters: {
            paid_date: query.paid_date,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      setModalLastPayment(true);
      setDataLastPayment(lastPayment);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingLastPayment(false);
    }
  };

  const onClickReset = async () => {
    try {
    } catch (error) {
      console.log("error", error);
    }
  };

  const addNewPeriod = () => {
    setIsNewPeriod(true);
    setFormNewPeriod((prev) => {
      return {
        ...prev,
        new_installments: cal_new_installment(formNewPeriod.number_period),
      };
    });
  };

  // สร้างงวดเพิ่มด้วยมือเฉพาะจำนวนที่ยังว่างก่อนครบ 120 งวด เพื่อให้ preview ตรงกับ backend guard
  const cal_new_installment = (number_period) => {
    let new_installments = [];
    let today = getCurrentLocalDateTime();
    let capitalRemain = data.capitalRemain;
    let last_installment = data.installments[data.installments.length - 1];
    let last_installment_datetime = getCurrentLocalDateTime(
      new Date(last_installment.date)
    );
    let currnt_month_index = last_installment_datetime.monthIndex;
    const installmentsToCreate = getAllowedNewInstallmentCount(
      data.installments,
      number_period
    );

    for (let index = 0; index < installmentsToCreate; index++) {
      let plus_mounth = 0;
      if (index === 0) {
        plus_mounth = 1;
      }
      let new_date_installment = new Date(last_installment_datetime.fullDate);
      const days = months[currnt_month_index].days;
      new_date_installment.setMonth(
        new_date_installment.getMonth() + index + plus_mounth
      );
      const interest =
        ((capitalRemain * (data.interest_rate / 100)) / 365) * days;

      const new_installment = {
        disabledPeriod: false,
        newInstallmentStatus: "creating",
        isNewInstallment: true,
        isNewInstallmentDate: today.isoDateTime,
        actualInterest: Math.ceil(Number(interest)),
        planInterest: Math.ceil(Number(interest)),
        actualPrinciple: 0,
        planCapitalRemain: capitalRemain,
        actualCapitalRemain: capitalRemain,
        planPrinciple: 0,
        receiveInterest: 0,
        interestMore: 0,
        days: +months[currnt_month_index].days,
        date: `${
          getCurrentLocalDateTime(new Date(new_date_installment)).fullDate
        }`,
        paid_interest_more: false,
        paid_date: "-",
        paid_amount: 0,
        paid_amount_interest_more: 0,
        overflow: 0,
        paid_overflow: false,
        paid_interest: false,
        penalty: 0,
      };

      currnt_month_index = new_date_installment.getMonth();
      new_installments.push(new_installment);
    }

    return new_installments;
  };

  const onChangeNewPeriod = (e) => {
    const value = e.target.value;
    setFormNewPeriod((prev) => {
      return {
        ...prev,
        number_period: value,
        new_installments: cal_new_installment(value),
      };
    });
  };

  const onCancelNewPeriod = () => {
    setIsNewPeriod(false);
    setFormNewPeriod((prev) => {
      return {
        ...prev,
        number_period: 6,
        new_installments: [],
      };
    });
  };

  const onUpdateInstallments = async () => {
    try {
      setLoadingUpdateInstallment(true);

      await API.put(
        "MoneyHubAdmin",
        `/loan/sandbox/update_installment/${data.loan_id}`,
        {
          body: {
            installments: [
              ...data.installments,
              ...formNewPeriod.new_installments.map((installment) => {
                return {
                  ...installment,
                };
              }),
            ],
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      await getData({ isLoading: true, params: query });
      setFormNewPeriod({ number_period: 6, new_installments: [] });
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingUpdateInstallment(false);
    }
  };

  let check_ems = true;

  if (data.ems_first && data.ems_second) {
    check_ems = false;
  }

  if (showModal)
    return (
      <div className="bg-gray-100 fixed z-20 inset-0 w-full h-screen mx-auto">
        <div className="w-full h-14 p-2 bg-white flex flex-row justify-end mb-4">
          <div className="w-full text-left mx-4 flex flex-row">
            <div className="h-full text-base mt-2 mx-4">
              {data.loan_kbank_id}
            </div>
            <div className="h-full text-base mt-2 mx-4">
              {data.name} {data.lastname}
            </div>
            <div className="h-full text-base mt-2 mx-4">
              วงเงิน {numeral(data.capitalRemain).format("0,00")}
            </div>
            <div className="h-full text-base mt-2 mx-4">
              ดอกเบี้ย สะสม {numeral(data.interestMore).format("0,00")} /
              ปัจจุบัน{" "}
              {numeral(
                data.installments.find(
                  (installment) => !installment.disabledPeriod
                ).actualInterest
              ).format("0,00")}
            </div>

            <div className="h-full text-base mt-2 mx-4"> {data.type}</div>
            <div className="h-full text-base mt-2 mx-4">
              {" "}
              {format(
                new Date(data.requestTime).getTime() + 432000000,
                "dd-MM-yyyy"
              )}
            </div>
          </div>
          <div className=" w-44">
            <Select
              // disabled
              options={optionsPeriod}
              value={getOption(optionsPeriod, form.newPeriod)}
              onChange={onSelect("newPeriod")}
            />
          </div>
          {/*}
          <div className=" w-52 mr-4">
            <Select
              isDisabled
              options={optionsPackage}
              value={getOption(optionsPackage, data.type)}
              onChange={onSelect("newInterest")}
            />
    </div>*/}
          <button
            disabled
            onClick={previewRefinance}
            className=" px-2 py-2 text-base rounded text-white bg-blue-500 mx-3"
          >
            Preview
          </button>
          <button
            onClick={() => setShowModal(false)}
            className="mx-0 px-4 py-2 text-base rounded text-white bg-red-500"
          >
            ยกเลิก
          </button>
          <button
            disabled
            onClick={onRefinance}
            className="mx-3 px-4 py-2 text-base rounded text-white bg-green-500"
          >
            ยืนยัน
          </button>
        </div>
        <div className="flex flex-row justify-center">
          <div className="overflow-y-scroll h-screen-80">
            {data?.installments?.map((installment, index) => {
              return (
                <div className="flex items-center justify-center w-full mx-auto">
                  <div
                    className={
                      "border " +
                      (index > 0 ? "border-t-0" : "") +
                      " border-gray-300 flex flex-row w-full justify-between items-center mx-4 my-0 py-4"
                    }
                  >
                    <div className="items-center px-2">
                      <div>งวดที่ </div>
                      <div className=" text-base font-bold mt-2">
                        {index + 1}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div>เงินต้นคงเหลือ</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.planCapitalRemain).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div>เงินค่างวด</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.actualPrinciple).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div>ดอกเบี้ย</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.planInterest).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div>สถานะงวด</div>
                      {!installment.disabledPeriod ? (
                        <div className=" text-base text-green-500 font-bold mt-2">
                          เปิด
                        </div>
                      ) : (
                        <div className=" text-base text-red-500 font-bold mt-2">
                          ปิด
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="flex flex-col my-auto mx-16">
            <svg
              className="p-4 w-20 h-20"
              xmlns="http://www.w3.org/2000/svg"
              // className="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div>

          <div className="overflow-y-scroll h-screen-80">
            {preview.map((installment, index) => {
              return (
                <div className="flex items-center justify-center w-full mx-auto">
                  <div
                    className={
                      "border " +
                      (index > 0 ? "border-t-0" : "") +
                      " border-gray-300 flex flex-row w-full justify-between items-center mx-4 my-0 py-4"
                    }
                  >
                    <div className="items-center px-2">
                      <div>งวดที่ </div>
                      <div className=" text-base font-bold mt-2">
                        {index + 1}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div>เงินต้นคงเหลือ</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.planCapitalRemain).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div>เงินค่างวด</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.actualPrinciple).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div>ดอกเบี้ย</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.planInterest).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div>สถานะงวด</div>
                      {!installment.disabledPeriod ? (
                        <div className=" text-base text-green-500 font-bold mt-2">
                          เปิด
                        </div>
                      ) : (
                        <div className=" text-base text-red-500 font-bold mt-2">
                          ปิด
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );

  const onClickViewBuro = async () => {
    try {
      setBuroData(
        getDetailSegment({
          currentDate: query?.paid_date,
          dataExport: [data],
          showLog: true,
          showConsole: true,
        })
      );
      setOpenBuro(true);

      // console.log("data", data);
      // console.log("query", query.paid_date);
    } catch (error) {
      console.log("error", error);
    }
  };

  const onClickReinstallment = async () => {
    try {
      setLoadingInstallment(true);
      // const dataReinstallment = await API.get(
      //   "MoneyHubAdmin",
      //   `/loan/sandbox/reinstallment/${data.loan_id}`,
      //   {
      //     queryStringParameters: {
      //       selectDate: query.paid_date,
      //     },
      //     headers: {
      //       Authorization: `Bearer ${(await Auth.currentSession())
      //         .getIdToken()
      //         .getJwtToken()}`,
      //     },
      //   }
      // );

      let loan = data;

      let reLoan = 
        reinstallments(loan, query.paid_date, loan.interest)
  

      let newLoan = calcuratorInterestTwo(
        { ...loan, ...reLoan },
        { dataInterest: loan.interest, where: { paid_date: query.paid_date } }
      );

      const copyLoan = newLoan
      newLoan.installments = newLoan.installments.map((installment) => {
        return {
          ...installment,
          interestMore: 0,
        };
      });

      console.log("newLoan", JSON.stringify(newLoan));
      // console.log("newInstallments", JSON.stringify(newInstallments));
      // return {
      //   ...newLoan,
      //   original: { ...loan },
      // };

      setData({ ...copyLoan, original: { ...loan } });

      // setData((prev) => {
      //   const newInstallments = _.cloneDeep(
      //     reinstallments(prev, query.paid_date, prev.interest)
      //   );

      //   const newLoan = calcuratorInterestTwo(
      //     { ...(prev.original ? prev.original : prev), ...newInstallments },
      //     { dataInterest: prev.interest, where: { paid_date: query.paid_date } }
      //   );

      //   console.log("newLoan", JSON.stringify(newLoan));
      //   return {
      //     ...newLoan,
      //     original: { ...prev },
      //   };
      // });
      // console.log("dataReinstallment", dataReinstallment);
    } catch (error) {
      console.log("reinstallment error", error);
    } finally {
      setLoadingInstallment(false);
    }
  };

  return (
    <div
      className="fixed z-20 inset-0 h-screen"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <ModalDialog
        title={`Debtor`}
        setModal={setModalDebtor}
        modal={modalDebtor}
        ref={cancelButtonRef}
        dataJson={dataDebtor}
      />
      <ModalDialog
        title={`Payment`}
        setModal={setModalAfterPayment}
        modal={modalAfterPayment}
        ref={cancelPaymentButtonRef}
        dataJson={dataAfterPayment}
      />
      <ModalDialog
        title={`Last Payment`}
        setModal={setModalLastPayment}
        modal={modalLastPayment}
        ref={cancelLastPaymentButtonRef}
        dataJson={dataLastPayment}
      />
      <ModalDialog
        title={`Buro`}
        isSearch
        search={search}
        setSearch={setSearch}
        setModal={setOpenBuro}
        modal={openBuro}
        ref={cancelBuroRef}
        onChangeSearch={onChangeSearch}
        dataJson={butoData}
      />

      {showEvidence != "" && (
        <S3Image
          className="w-full h-full object-contain fixed z-30 bg-black bg-opacity-60"
          imgKey={showEvidence}
          onClick={() => showEvidencePopup("")}
        />
      )}
      <div className="flex flex-row">
        <div
          id="box-installment"
          className="overflow-y-scroll overflow-auto h-screen inline-block align-bottom border-b w-4/5 border-gray-300 bg-gray-100 rounded-none text-left shadow-xl transform transition-all sm:my-0 sm:align-middle "
        >
          <div className=" pt-4 pb-4 sm:p-2 border-b border-gray-300 shadow-sm">
            <div className="flex items-center">
              {/*
              <div className="pr-4 py-2  sm:flex sm:flex-row-reverse">
                <React.Fragment>
                  <button
                    onClick={() => router.push("/loan")}
                    type="button"
                    className="mt-3 w-full inline-flex justify-center rounded-md border shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  >
                    Back
                  </button>
                </React.Fragment>
              </div>*/}
              <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-blue-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                <h3
                  className="text-lg leading-6 font-medium text-gray-400"
                  id="modal-title"
                >
                  <span className="text-blue-500">{data.loan_kbank_id}</span>
                  {"  | "}{" "}
                  <span className="text-gray-700">
                    {data.name} {data.lastname}
                  </span>
                  {"  | "}{" "}
                  <span className="text-gray-700">{data.phone_number}</span>
                  {"  | "}{" "}
                  <span className={colorStatus(data.loan_status)}>
                    {data.loan_status}
                  </span>
                  {"  | "}{" "}
                  <span className={"text-green-400"}>
                    ส่วนลด {data.promo} %
                  </span>
                </h3>
              </div>
              <input
                className="border p-2 w-80"
                value={query.paid_date}
                type="date"
                onChange={onChangeDate}
              />
              <button
                onClick={onRefetch}
                className="mx-3 px-4 py-2 text-base rounded text-white bg-purple-500"
              >
                Date
              </button>
              <button
                onClick={onClickViewBuro}
                className={classNames(
                  "px-4 py-2 w-32 text-base rounded text-white ",
                  {
                    "bg-gray-400 cursor-not-allowed": loadingBuro,
                    "bg-green-500 cursor-pointer": !loadingBuro,
                  }
                )}
              >
                View
              </button>
              <button
                onClick={onClickReinstallment}
                className={classNames(
                  "px-4 py-2 w-32 text-base rounded text-white ",
                  {
                    "bg-gray-400 cursor-not-allowed": loadingInstallment,
                    "bg-green-500 cursor-pointer": !loadingInstallment,
                  }
                )}
              >
                Reinstallment
              </button>
              <button
                disabled={loadingDebtor}
                onClick={onClickDebtor}
                className={classNames(
                  "px-4 py-2 w-32 text-base rounded text-white ",
                  {
                    "bg-gray-400 cursor-not-allowed": loadingDebtor,
                    "bg-green-500 cursor-pointer": !loadingDebtor,
                  }
                )}
              >
                {loadingDebtor && (
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx={12}
                      cy={12}
                      r={10}
                      stroke="currentColor"
                      strokeWidth={4}
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                  </svg>
                )}{" "}
                Debtor
              </button>
              <button
                disabled={loadingPayment}
                onClick={onClickAfterPayment}
                className={classNames(
                  "px-4 py-2 w-32 text-base rounded text-white ",
                  {
                    "bg-gray-400 cursor-not-allowed": loadingPayment,
                    "bg-green-500 cursor-pointer": !loadingPayment,
                  }
                )}
              >
                {loadingPayment && (
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx={12}
                      cy={12}
                      r={10}
                      stroke="currentColor"
                      strokeWidth={4}
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                  </svg>
                )}{" "}
                Payment
              </button>
              {/* <button
                disabled={loadingLastPayment}
                onClick={onClickLastPayment}
                className={classNames(
                  "px-4 py-2 w-32 text-base rounded text-white ",
                  {
                    "bg-gray-400 cursor-not-allowed": loadingLastPayment,
                    "bg-green-500 cursor-pointer": !loadingLastPayment,
                  }
                )}
              >
                {loadingLastPayment && (
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx={12}
                      cy={12}
                      r={10}
                      stroke="currentColor"
                      strokeWidth={4}
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                  </svg>
                )}{" "}
                Payment 2
              </button> */}
              {/* <button
                disabled={loadingLastPayment}
                onClick={onClickLastPayment}
                className="px-4 py-2 w-48 text-base rounded text-white "
                className={classNames(
                  "px-4 py-2 w-32 text-base rounded text-white ",
                  {
                    "bg-gray-400 cursor-not-allowed": loadingLastPayment,
                    "bg-blue-500 cursor-pointer": !loadingLastPayment,
                  }
                )}
              >
                {loadingLastPayment && (
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx={12}
                      cy={12}
                      r={10}
                      stroke="currentColor"
                      strokeWidth={4}
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                  </svg>
                )}{" "}
                Reset Loan
              </button> */}
              {/* {data.loan_status !== "FAILD" &&
                checkRole(user.groups, [
                  "SuperAdmin",
                  "AnalyzeApprove",
                  "Debt",
                ]) && (
                  <button
                    disabled
                    onClick={onFail}
                    className="px-4 py-2 w-32 text-base rounded text-white "
                    className={classNames(
                      "px-4 py-2 w-32 text-base rounded text-white",
                      {
                        "bg-red-500 cursor-pointer": !check_ems,
                        "bg-gray-400 cursor-not-allowed": check_ems,
                      }
                    )}
                  >
                    Fail
                  </button>
                )}
              {data.loan_status !== "REFINANCE" &&
                checkRole(user.groups, [
                  "SuperAdmin",
                  "AnalyzeApprove",
                  "Debt",
                ]) && (
                  <button
                    disabled={data?.refinance_amount > 0}
                    onClick={previewRefinance}
                    className={classNames(
                      "mx-3 px-4 py-2 text-base rounded text-white ",
                      {
                        "bg-gray-400 cursor-not-allowed":
                          data?.refinance_amount > 0,
                        "bg-purple-500 cursor-pointer":
                          data?.refinance_amount === 0,
                      }
                    )}
                  >
                    Refinance
                  </button>
                )} */}

              {data?.refinance_amount > 0 && (
                <div className="mx-3 px-4 py-2 text-base rounded text-white bg-purple-500">
                  กำลังรีไฟแนนท์
                </div>
              )}
              {/*
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                <h3
                  className="text-lg leading-6 font-medium text-gray-900"
                  id="modal-title"
                >
                  <div>งวด</div>
                  <input
                    type="text"
                    name="newPeriod"
                    disabled
                    className="w-18 m-3 mt-0 p-1 border border-gray-300 rounded"
                    onChange={onChangeForm}
                    value={form.newPeriod}
                  />
                  <Select
                    name="newInterest"
                    onChange={onChangeSelect}
                    value={{
                      label: form.newInterest,
                      value: form.newInterest,
                    }}
                    options={optionsInterest}
                  />
                 
                </h3>
              </div>
                  )}*/}
            </div>
          </div>
          <div className="bg-gray-50 my-1 text-center">
            <div className="grid grid-cols-6 max-w-7xl  mx-auto py-4 font-bold text-sm">
              <div>ประเภท : {data.type}</div>
              <div>ยอดเงินกู้ : {numeral(data.initCapital).format("0,0")}</div>
              <div
                className={classNames("mx-4", {
                  "text-red-400": data.capitalRemain < 0,
                })}
              >
                เงินกู้คงเหลือ : {numeral(data.capitalRemain).format("0,0")}
              </div>
              <div className="mx-4">
                รวมดอกเบี้ยสะสม : {numeral(data.interestMore).format("0,0")}
              </div>
              <div>
                รวมยอดจ่ายเกินสะสม (โปะ) :{" "}
                {numeral(data.overflow).format("0,0")}
              </div>
              {data.loan_status !== "DONE" && (
                <div>
                  วันกำหนดชำระ :{" "}
                  {format(new Date(data.overdue_date), "dd-MM-yyyy")}
                </div>
              )}
            </div>

            <div className="grid grid-cols-5 text-sm  max-w-7xl mx-auto py-4 font-bold text-gray-600 bg-gray-100">
              <div>เลขบัตรประชาชน : {data.citizenid}</div>
              <div>วันเกิด : {data.birthdateTh}</div>
              <div>เลขบัญชี : {data.bankNo}</div>
              <div className="col-span-2">
                ที่อยู่ปัจจบุัน : {data.officialAddressCode}{" "}
                {data.officialAddressDesc} {data.currentAddress}
              </div>
            </div>

            {data.loan_status == "FAIL" && (
              <div className="p-4 px-8 border bg-red-100 border-red-500 max-w-md  mx-auto relative">
                <div className="text-lg text-red-600 font-bold">
                  ล้มเหลวเนื่องจาก {data.reason}{" "}
                </div>
                <div className="text-red-500"> โดย {data.adminName} </div>
              </div>
            )}

            {data.loan_status !== "REFINANCE" &&
              data.loan_status !== "FAIL" &&
              !checkRole(user.groups, ["Marketing"]) && (
                <div className="flex flex-row justify-between max-w-2xl mx-auto py-4 font-bold text-base">
                  <div className="p-4 px-6 border bg-gray-100 border-gray-500  mx-auto relative">
                    {isExpand ? (
                      <div>
                        <div>คำขอชำระค่างวด</div>
                        <div
                          onClick={() => setExpand(false)}
                          className="absolute top-1 right-2 text-blue-500 text-base"
                        >
                          ซ่อน
                        </div>
                        <div className={classNames("grid mt-2 grid-cols-1")}>
                          <div className="w-full h-64 bg-gray-200">
                            <div className="bg-black h-52 flex flex-col justify-center">
                              <FullScreen
                                className="w-full h-full"
                                handle={handleApprove}
                              >
                                {billBase || dataEvidence === null ? (
                                  billBase && (
                                    <img
                                      src={billBase}
                                      onClick={handleApprove.enter}
                                      className="w-full h-full object-contain bg-black"
                                    />
                                  )
                                ) : (
                                  <S3Image
                                    onClick={() =>
                                      showEvidencePopup(dataEvidence?.bill_img)
                                    }
                                    className="w-full h-52 object-contain bg-black "
                                    imgKey={
                                      dataEvidence?.bill_img === undefined
                                        ? ""
                                        : dataEvidence.bill_img
                                    }
                                  />
                                )}
                              </FullScreen>
                            </div>
                            <div className="flex flex-col h-20 justify-between mx-2  mt-1 p-1">
                              <input
                                type="file"
                                className="tex-xs"
                                onChange={onChangeFile}
                                name="bill_img"
                                value={form?.bill_img?.file}
                              />
                              {error && !billBase && (
                                <div className="flex">
                                  <span className="text-red-400 text-sm">
                                    โปรดเลือกไฟล์
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="w-full text-left text-gray-700 text-base mx-3 mt-2">
                            ยอดเงิน
                          </div>
                          <input
                            type="text"
                            className="w-full m-3 mt-0 p-1 border border-gray-300 rounded"
                            onChange={onChangeForm}
                            name="paid_amount"
                            value={form.paid_amount}
                          />
                          {error && form.paid_amount === 0 && (
                            <div className="flex mx-3">
                              <span className="text-red-400 text-sm">
                                โปรดกรอกจำนวนเงิน
                              </span>
                            </div>
                          )}
                          <div className="w-full text-left text-gray-700 text-base mx-3">
                            วัน/เวลา ที่ชำระ
                          </div>
                          <div className="mx-3 w-full grid grid-cols-12 gap-1 ">
                            <div className=" col-span-2">
                              <div className="text-left">Date</div>
                              <Select
                                options={optionsDates}
                                value={{
                                  label: `${pad(selectDate)}`,
                                  value: `${pad(selectDate)}`,
                                }}
                                onChange={(e) => onSelectDate(e)}
                              />
                            </div>
                            <div className="col-span-3">
                              <div className="text-left">Month</div>
                              <Select
                                options={optionsMonths}
                                value={{
                                  label: `${pad(selectMonth)}`,
                                  value: `${pad(selectMonth)}`,
                                }}
                                onChange={(e) => onSelectMonth(e)}
                              />
                            </div>
                            <div className="col-span-3">
                              <div className="text-left">Year</div>
                              <Select
                                options={optionsYears}
                                value={{
                                  label: selectYear,
                                  value: selectYear,
                                }}
                                onChange={(e) => onSelectYear(e)}
                              />
                            </div>
                            <div className="col-span-2">
                              <div className="text-left">Hour</div>
                              <Select
                                options={optionsHours}
                                value={{
                                  label: `${pad(selectHour)}`,
                                  value: `${pad(selectHour)}`,
                                }}
                                onChange={(e) => onSelectHour(e)}
                              />
                            </div>
                            <div className="col-span-2">
                              <div className="text-left">Minutes</div>
                              <Select
                                options={optionsMintues}
                                value={{
                                  label: `${pad(selectMinute)}`,
                                  value: `${pad(selectMinute)}`,
                                }}
                                onChange={(e) => onSelectMintue(e)}
                              />
                            </div>
                          </div>
                          {/* <input
                            type="datetime-local"
                            className="w-full m-3 mt-0 p-1 border border-gray-300 rounded"
                            onChange={onChangeForm}
                            name="paid_date"
                            value={form.paid_date}
                            max={getCurrentLocalDateTime().dateTimeLocal}
                          /> */}
                          <React.Fragment>
                            <button
                              onClick={onSubmitEvidence("APPROVE")}
                              className="mt-2 mx-3 px-4 py-1 w-full rounded text-white text-sm shadow-sm duration-300 transition-all focus:outline-none bg-green-500 hover:bg-green-600"
                            >
                              อนุมัติ
                            </button>
                            {dataEvidence && (
                              <button
                                onClick={onSubmitEvidence("REJECT")}
                                className=" px-4 py-1 mt-2 w-full mx-3 rounded text-red-500 border border-red-500 text-sm shadow-sm duration-300 transition-all focus:outline-none hover:bg-red-600 hover:text-white"
                              >
                                ปฎิเสธ
                              </button>
                            )}
                          </React.Fragment>
                        </div>
                      </div>
                    ) : (
                      <button onClick={() => setExpand(true)}>
                        จัดการยอดเงิน
                      </button>
                    )}
                  </div>
                </div>
              )}
            {data?.installments.map((installment, index) => {
              // const disableRemain = calculatorDisabledPeriodRemain(
              //   data.installments,
              //   query.paid_date
              // );

              // let totalRemain = 0;
              // let capInstallmentRemain = 0;
              // if (disableRemain.matchIndex === index) {
              //   totalRemain = disableRemain.disabledPeriodRemain;
              // }

              // if (installment.isNewInstallment) {
              //   capInstallmentRemain += data.capitalRemain;
              // }

              const currentDateIndex = getCheckCurrentDate(data?.installments);
              const checkCurrentDateIndex = currentDateIndex === index;
              const total = getTotalAmount(
                checkCurrentDateIndex,
                data,
                installment,
                index
              );

              return (
                <div
                  key={index}
                  className="flex items-center justify-center w-full mx-auto relative"
                >
                  {/* {installment.newInstallmentStatus === "created" && (
                      <div className=" text-red-500 text-xs mr-3 mt-1 absolute top-0 right-0">
                        New
                      </div>
                    )} */}

                  <div
                    className={classNames(
                      "border-b border-gray-300 flex flex-row w-full justify-between items-center rounded mx-4 my-0 py-4",
                      {
                        "bg-lightBlue-50": installment.isNewInstallment,
                      }
                    )}
                  >
                    <div className="items-center px-2">
                      <div className="text-sm">งวดที่ </div>
                      <div className=" text-base font-bold mt-2">
                        {index + 1}
                      </div>
                    </div>

                    <div className=" items-center px-2">
                      <div className="text-sm">เงินต้นคงเหลือ</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.planCapitalRemain).format("0,0")}
                      </div>
                    </div>

                    <div className=" items-center px-2">
                      <div className="text-sm">เงินค่างวด</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.planPrinciple).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div className="text-sm">ดอกเบี้ย</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.planInterest).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div className="text-sm  text-blue-500 ">
                        เงินค่างวดคงเหลือ
                      </div>
                      <div className=" text-base text-blue-500 font-bold mt-2">
                        {numeral(installment.actualPrinciple).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div className="text-sm text-blue-500">
                        ดอกเบี้ยคงเหลือ
                      </div>
                      <div className=" text-base text-blue-500  font-bold mt-2">
                        {numeral(installment.actualInterest).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div className="text-sm text-blue-500 ">ดอกเบี้ยสะสม</div>
                      <div className=" text-base text-blue-500  font-bold mt-2">
                        {numeral(installment.interestMore).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div className="text-sm text-red-500 ">วันที่หัก</div>
                      <div className=" text-base text-red-500 font-bold mt-2">
                        {format(new Date(installment.date), "dd-MM-yyyy")}
                      </div>
                    </div>
                    <div className=" items-center px-2 w-32">
                      <div className="text-sm text-red-500">วันที่จ่าย</div>
                      <div className=" text-base text-red-500 font-bold mt-2">
                        {installment.paid_date !== "-"
                          ? format(
                              new Date(installment.paid_date),
                              "dd-MM-yyyy"
                            )
                          : "-"}
                      </div>
                    </div>

                    <div className="items-center px-2">
                      <div className="text-sm">จ่ายแล้ว</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.paid_amount).format("0,0")}
                      </div>
                    </div>

                    <div className=" items-center px-2">
                      <div className="text-sm">คงเหลือประจำงวด</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(total).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div className="text-sm">สถานะ</div>
                      {!installment.disabledPeriod ? (
                        <div className=" text-base text-green-500 font-bold mt-2">
                          เปิด (
                          {differenceInDays(
                            query.paid_date
                              ? new Date(query.paid_date)
                              : new Date(),
                            new Date(installment.date)
                          )}
                          )
                        </div>
                      ) : (
                        <div className=" text-base text-red-500 font-bold mt-2">
                          ปิด (
                          {differenceInDays(
                            query.paid_date
                              ? new Date(query.paid_date)
                              : new Date(),
                            new Date(installment.date)
                          )}
                          )
                        </div>
                      )}
                      {/* {[
                        "ปิด-เลท",
                        "ค้างชำระ",
                        "ปิด-ตรงเวลา",
                        "ปิด-โปะ",
                      ].includes(installment.displayStatus) ? (
                        <div className=" text-base text-red-500 font-bold mt-2">
                          {installment.displayStatus === "ปิด-ตรงเวลา" ? (
                            <div className="flex flex-col">
                              <div>ปิด</div>
                              <div>ตรงเวลา</div>
                            </div>
                          ) : (
                            installment.displayStatus
                          )}
                        </div>
                      ) : (
                        <div className=" text-base text-green-500 font-bold mt-2">
                          {installment.displayStatus}
                        </div>
                      )} */}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {/* Add new period */}
          {/* <div
            className={classNames(
              "flex items-center mx-5 mb-12 mt-6 border-dashed border-2  border-blue-300 justify-center py-6 px-3",
              {
                "sticky bottom-0 bg-white": formNewPeriod.number_period > 7,
              }
            )}
          >
            {isNewPeriod ? (
              <div className="flex items-center w-full mx-2justify-between">
                <div className="w-2/3 flex space-x-4  items-center">
                  <div className="flex items-center space-x-2">
                    <div className="">เงินต้นคงเหลือ</div>
                    <input
                      disabled
                      className="px-3 py-2 rounded border-gray-300 border"
                      defaultValue={data.capitalRemain}
                    />
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="">จำนวดงวด</div>
                    <input
                      onChange={onChangeNewPeriod}
                      type="number"
                      min={0}
                      max={MAX_INSTALLMENTS}
                      value={formNewPeriod.number_period}
                      className="px-3 py-2 w-36 rounded border-gray-300 border"
                    />
                  </div>
                </div>
                <div className=" w-2/6 flex justify-end mx-2 space-x-2">
                  <button
                    disabled={loadingUpdateInstallment}
                    onClick={onUpdateInstallments}
                    className={classNames(
                      " text-white text-sm px-3 py-2 rounded  duration-150 transition-all",
                      {
                        "bg-green-500 hover:bg-green-400 cursor-pointer":
                          !loadingUpdateInstallment,
                        "bg-gray-400 cursor-not-allowed":
                          loadingUpdateInstallment,
                      }
                    )}
                  >
                    {loadingUpdateInstallment && (
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx={12}
                          cy={12}
                          r={10}
                          stroke="currentColor"
                          strokeWidth={4}
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                      </svg>
                    )}
                    บันทึก
                  </button>
                  <button
                    onClick={onCancelNewPeriod}
                    className="bg-red-500 text-white text-sm px-3 py-2 rounded hover:bg-red-400 duration-150 transition-all"
                  >
                    ยกเลิก
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={addNewPeriod}
                className="px-4 py-3 bg-blue-500 rounded text-white hover:bg-blue-400 duration-150 transition-all"
              >
                Add new period
              </button>
            )}
          </div> */}
        </div>

        <div className="w-1/5 bg-gray-200 h-screen  overflow-y-scroll">
          <div className="text-black text-lg text-center mt-4">
            หลักฐานการชำระเงิน
          </div>
          <div className="m-4">
            {data.interestMoreList?.length > 0 &&
              data.interestMoreList.map((interestMore) => (
                <div className="bg-gray-100 rounded border-b gray-300 p-2">
                  <div className="flex flex-row justify-between">
                    <div className="text-sm"> ลดดอกเบี้ยสะสมจำนวน</div>
                    <div className="text-purple-500 text-sm">
                      {numeral(interestMore.paid_amount).format("0,0.00")}
                    </div>
                  </div>
                  <div className="text-xs font-medium text-gray-500">
                    {" "}
                    เหตุผล: {interestMore.reason}
                  </div>
                  <div className="text-xs text-blue-500">
                    {format(
                      new Date(interestMore.paid_date),
                      "dd/MM/yyyy HH:mm"
                    )}
                  </div>
                  <div className="text-xs">โดย {interestMore.adminName}</div>
                </div>
              ))}
          </div>

          {evidence.map((ev, index) => {
            return (
              <div
                className={
                  "m-3 py-0 flex flex-row " +
                  (index > 0 && ev.period != evidence[index - 1].period
                    ? "border-t border-gray-400 pt-3 "
                    : "py-0 m-3")
                }
              >
                {ev?.transactionId ? (
                  <img src="/kbank.jpg" className="w-20  h-24 object-cover" />
                ) : (
                  <S3Image
                    className="w-20 bg-black h-24 object-cover"
                    imgKey={ev.bill_img}
                    onClick={() => showEvidencePopup(ev.bill_img)}
                  />
                )}
                <div className="ml-4">
                  <div className={classNames("text-base")}>
                    {" "}
                    {ev.evidence_status === "APPROVE"
                      ? `งวดที่ ${ev.period}`
                      : `งวดที่ -`}
                  </div>
                  <div className="text-sm text-gray-700">
                    {numeral(ev.paid_amount).format("0,0.00")}
                  </div>
                  <div className="text-xs flex flex-row w-full space-x-1">
                    (
                    <div className="text-blue-500 flex space-x-1">
                      <div>เงินต้น</div>
                      <div>{numeral(ev.paid_principle).format("0,0")},</div>
                    </div>
                    <div className="text-green-500 flex space-x-1">
                      <div>โปะ</div>
                      <div>{numeral(ev.paid_overflow).format("0,0")},</div>
                    </div>
                    )
                  </div>
                  <div className="text-xs flex flex-row w-full space-x-1">
                    (
                    <div className="text-orange-500 flex space-x-1">
                      <div>ดอกเบี้ย</div>
                      <div>{numeral(ev.paid_interest).format("0,0")},</div>
                    </div>
                    <div className="text-red-500 flex space-x-1">
                      <div>ดอกเบี้ยสะสม</div>
                      <div>{numeral(ev.paid_interestMore).format("0,0")}</div>
                    </div>
                    )
                  </div>
                  <div className="text-xs text-blue-500">
                    {format(new Date(ev.paid_date), "dd/MM/yyyy HH:mm")}
                  </div>
                  <div
                    className={
                      ev.evidence_status == "APPROVE"
                        ? "text-green-500 text-xs"
                        : "text-red-500 text-xs"
                    }
                  >
                    {ev.evidence_status}
                  </div>
                  {ev?.transactionId ? (
                    <div className="text-xs text-gray-600">
                      {ev.transactionId}
                    </div>
                  ) : (
                    <div className="text-xs">โดย {ev.adminName}</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default LoanId;
